import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import Droppable from '@client/components/DroppableWrapper'
import ColumnModel from '@client/components/DroppableWrapper/model'
import Draggable from '@client/components/DraggableWrapper'
import Block from '@client/components/Block'
import SectionModel, {
  NULL as SectionModelNULL,
} from '@client/components/Section/model'
import Placeholder from '@client/components/Placeholder'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import {
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_FORM_SUBTYPE_SUCCESS,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
  ITEM_TYPE_CONFIRMATION_MAIL,
  ITEM_TYPE_MAIL,
  ITEM_TYPE_RESPONDER,
  WIZARD_TYPE_PAGE,
  BUTTON_BORDER_STYLES,
} from '@client/components/Editor/settings'
import {
  FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES,
  SECTION_TYPES,
  SECTION_LAYOUTS,
  SECTION_VERTICAL_ALIGN_EMAIL_MAP,
} from '@client/components/Section/constants'
import { BLOCK_TYPES } from '@client/components/Block/constants'
import inlineStyles from './inlineStyles'

import './styles.scss'

export class SectionColumn extends Component {
  static propTypes = {
    column: PropTypes.instanceOf(ColumnModel).isRequired,
    acceptTypes: PropTypes.array,
    app: PropTypes.instanceOf(AppModel),
    model: PropTypes.instanceOf(SectionModel),
    serverRender: PropTypes.bool,
    editor: PropTypes.instanceOf(EditorModel),
  }

  static defaultProps = {
    column: new ColumnModel(),
    acceptTypes: [],
    app: AppModelNULL,
    model: SectionModelNULL,
    serverRender: false,
    editor: EditorModelNULL,
  }

  render() {
    const {
      index,
      column,
      acceptTypes,
      model,
      serverRender,
      editor,
      app,
      count,
    } = this.props
    const { formatMessage } = app
    const columnIndex = index

    let columnStyles
    if (
      editor.kind === ITEM_TYPE_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
      editor.kind === ITEM_TYPE_SURVEY ||
      editor.kind === ITEM_TYPE_SURVEY_THANK_YOU
    ) {
      columnStyles = {
        ...inlineStyles.column,
      }
    } else {
      columnStyles = {
        ...inlineStyles.column,
        ...model.columnStyles,
      }
    }

    let borderStyles = {}

    if (
      model.settings.values.borderStyle &&
      model.settings.values.borderStyle !== BUTTON_BORDER_STYLES[0].value &&
      model.isBoxed
    ) {
      borderStyles = { ...borderStyles, ...model.borderStyles, ...model.borderRadiusStyles }
    }

    if (
      editor.kind === ITEM_TYPE_FORM &&
      model.settings.values.bgImagePosition ===
        FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[3].value &&
      index === 0
    ) {
      return null
    }

    if (
      editor.kind === ITEM_TYPE_FORM &&
      editor.subKind === ITEM_TYPE_FORM_SUBTYPE_SUCCESS &&
      index === 1
    ) {
      return null
    }

    let rowClassName

    if (
      editor.kind === ITEM_TYPE_FORM &&
      editor.subKind !== ITEM_TYPE_FORM_SUBTYPE_SUCCESS &&
      index === 1
    ) {
      rowClassName = 'row-form'
    }

    if (
      editor.kind === ITEM_TYPE_FORM &&
      editor.subKind !== ITEM_TYPE_FORM_SUBTYPE_SUCCESS &&
      index === 2
    ) {
      rowClassName = 'row-success'
      columnStyles.display = 'none'
    }

    if (!serverRender) {
      columnStyles.position = 'relative'
    }

    if (model.isBoxed) {
      columnStyles.backgroundColor =
        model.settings.values.backgroundColor ||
        editor.settings.values.contentColor
    }

    if (model.isFullWidth || editor.kind === ITEM_TYPE_FORM) {
      columnStyles.backgroundImage = ''
      let backgroundImage =
        (model.isFullWidth || editor.kind === ITEM_TYPE_FORM) && !!model.settings.values.backgroundImageUrl
          ? model.settings.values.backgroundImageUrl || ''
          : ''

      if (backgroundImage) {
        if (editor.kind === ITEM_TYPE_FORM && index === 0) {
          columnStyles.backgroundImage = backgroundImage
        }
      }

      if (columnStyles.backgroundImage) {
        columnStyles.backgroundPosition = 'center'
        columnStyles.backgroundSize = 'cover'
      }
    }

    if (
      editor.kind === ITEM_TYPE_PAGE  ||
      editor.kind === ITEM_TYPE_LANDING_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
      editor.kind === ITEM_TYPE_SURVEY ||
      editor.kind === ITEM_TYPE_SURVEY_THANK_YOU
    ) {
      if (model.sectionType === SECTION_TYPES.LANDINGTWOCOL) {
        if (index === 0) {
          columnStyles.width = `${(model.settings.values.firstColumnWidthPersent || 50).toFixed(2)}%`
        } else if (index === 1 || index === 2) {
          columnStyles.width = `${(100 - (model.settings.values.firstColumnWidthPersent || 50)).toFixed(2)}%`
        }
      } else {
        columnStyles.width = `${(100 / (model.columns?.length || 1)).toFixed(2)}%`
      }
    }

    if (
      app.wizard.type === WIZARD_TYPE_PAGE && (
        editor.kind === ITEM_TYPE_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE ||
        editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS
      ) && (
        model.sectionType === SECTION_TYPES.LANDINGONECOL ||
        model.sectionType === SECTION_TYPES.LANDINGTWOCOL
      )
    ) {
      let paddingStyles = {}
      let columnClassName = ''
      if (model.settings.values.layout === SECTION_LAYOUTS[0].value) {
        columnClassName = ``
      } else if (model.settings.values.layout === SECTION_LAYOUTS[1].value) {
        columnClassName = ``
      } else if (model.settings.values.layout === SECTION_LAYOUTS[2].value) {
        columnClassName = `content-background padding`
        paddingStyles = {
          paddingLeft: typeof model.settings.values.sidePadding !== 'undefined'
            ? `${model.settings.values.sidePadding}px`
            : undefined,
          paddingRight: typeof model.settings.values.sidePadding !== 'undefined'
            ? `${model.settings.values.sidePadding}px`
            : undefined,
        }
      }
      return (
        <Droppable model={column} acceptTypes={acceptTypes}>
          <div
            style={{
              ...columnStyles,
              ...borderStyles,
              ...paddingStyles,
              width: columnStyles.width ? columnStyles.width : '100%',
              backgroundImage: undefined,
            }}
            className={`column ${columnClassName} ${
              serverRender
                ? ''
                : `section-container ${column.classNames(
                    this.props.app.draggedComponent.type
                  )}`
            } ${model.settings.values.stackColumnsOnMobile ? 'stack' : ''}`}
            data-content={
              serverRender
                ? undefined
                : formatMessage('column.empty-column.placeholder')
            }
          >
            <For each="item" index="index" of={column.items}>
              <Draggable data={item} move={true} key={item.id} isDraggable={item.type !== BLOCK_TYPES.PRODUCT}>
                <Block
                  app={app}
                  editor={editor}
                  component={item}
                  index={index}
                  container={column}
                  serverRender={serverRender}
                  section={model}
                  columnIndex={columnIndex}
                />
              </Draggable>
            </For>
            <If condition={!this.props.serverRender}>
              <Placeholder position={column.placeholderPosition} />
            </If>
          </div>
        </Droppable>
      )
    }

    if (editor.kind === ITEM_TYPE_FORM) {
      if (
        editor.viewMode !== 'mobile' &&
        model.sectionType == SECTION_TYPES.FORMCOL &&
        (model.settings.values.bgImagePosition ===
          FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[0].value ||
          model.settings.values.bgImagePosition ===
            FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[2].value)
      ) {
        // Mobile view drops the popupWidth-derived pixel split; the
        // .form-editor-wrapper.mobile-view rules hide the image column and let
        // the form column run full-width, matching the preview iframe.
        if (index === 0) {
          columnStyles.width =
            ((editor.popupWidth || 0) *
              model.settings.values.firstColumnWidthPersent) /
            100
        } else if (index === 1 || index === 2) {
          columnStyles.width =
            ((editor.popupWidth || 0) *
              (100 - model.settings.values.firstColumnWidthPersent)) /
            100
        }
      } else if (
        model.sectionType == SECTION_TYPES.FORMCOL &&
        model.settings.values.bgImagePosition ===
          FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES[1].value &&
        index === 0
      ) {
        columnStyles.display = 'flex'
        if (editor.form_type === 'popup') {
          columnStyles.maxHeight = `200px`
          columnStyles.minHeight = `200px`
        } else if (editor.form_type === 'slide_in') {
          columnStyles.maxHeight = `150px`
          columnStyles.minHeight = `150px`
        }
        columnStyles.overflow = `hidden`
        columnStyles.flex = `1 0 100%`
      } else {
        columnStyles.flex = `1 0 100%`
      }
    }

    if (editor.kind === ITEM_TYPE_FORM && index === 0) {
      return (
        <div
          className={`column ${
            editor.kind === ITEM_TYPE_FORM
              ? `gan-column-bg-image bg-image-position-${model.settings.values.bgImagePosition}`
              : ''
          } ${model.settings.values.stackColumnsOnMobile ? 'stack' : ''}`}
          style={{
            ...columnStyles,
            backgroundImage: columnStyles.backgroundImage
              ? `url('${columnStyles.backgroundImage}')`
              : undefined,
          }}
        >
          <div className={serverRender ? undefined : 'full-width'}>
            <div className={serverRender ? '' : `section-container`}>
              <For each="item" index="index" of={column.items}>
                <Block
                  key={item.id}
                  app={app}
                  editor={editor}
                  component={item}
                  index={index}
                  container={column}
                  section={model}
                  columnIndex={columnIndex}
                  serverRender={serverRender}
                />
              </For>
            </div>
          </div>
        </div>
      )
    }

    if (
      editor.kind === ITEM_TYPE_FORM ||
      editor.kind === ITEM_TYPE_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE ||
      editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
      editor.kind === ITEM_TYPE_SURVEY ||
      editor.kind === ITEM_TYPE_SURVEY_THANK_YOU
    ) {
      return (
        <div
          className={`column ${
            editor.kind === ITEM_TYPE_FORM
              ? `gan-column-form bg-image-position-${model.settings.values.bgImagePosition} ${rowClassName}`
              : ''
          } ${model.settings.values.stackColumnsOnMobile ? 'stack' : ''}`}
          style={{
            ...columnStyles,
            ...(rowClassName === 'row-form' || rowClassName === 'row-success'
              ? {
                  position: 'relative',
                }
              : {}),
            backgroundImage: columnStyles.backgroundImage
              ? `url('${columnStyles.backgroundImage}')`
              : undefined,
            padding: editor.kind === ITEM_TYPE_FORM ? editor.form_type === 'popup' ? '40px 0 0' : '30px 0 0' : '0',
            ...(editor.kind !== ITEM_TYPE_FORM ? borderStyles : {}),
          }}
        >
          <div className={serverRender ? undefined : 'full-width'}>
            <Droppable model={column} acceptTypes={acceptTypes}>
              <div
                className={
                  serverRender
                    ? 'section-container'
                    : `section-container ${column.classNames(
                        this.props.app.draggedComponent.type
                      )}`
                }
                data-content={
                  serverRender
                    ? undefined
                    : formatMessage('column.empty-column.placeholder')
                }
                style={editor.kind === ITEM_TYPE_SURVEY ? {
                  paddingBottom: '40px',
                } : {}}
              >
                <For each="item" index="index" of={column.items}>
                  <Draggable
                    data={item}
                    move={true}
                    isDraggable={item.type !== BLOCK_TYPES.SUBMIT_BUTTON && item.type !== BLOCK_TYPES.PRODUCT}
                    key={item.id}
                  >
                    <Block
                      app={app}
                      editor={editor}
                      component={item}
                      index={index}
                      container={column}
                      serverRender={serverRender}
                      section={model}
                      columnIndex={columnIndex}
                    />
                  </Draggable>
                </For>
                <If condition={!this.props.serverRender}>
                  <Placeholder position={column.placeholderPosition} />
                </If>
              </div>
            </Droppable>
          </div>
          {editor.kind === ITEM_TYPE_FORM && (
            <div
              style={{
                fontSize: '12px',
                fontFamily: 'ui-sans, sans-serif',
                color: editor.settings.values.normalText_color,
                height: '40px',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                paddingBottom: '5px',
              }}
            >
              <span style={{ marginRight: '3px' }}>Powered by</span>
              <a
                style={{
                  color: editor.settings.values.normalText_color,
                  textDecoration: 'underline',
                }}
                href="https://www.getanewsletter.com/?a_aid=a53911&utm_source=freeaccount&utm_medium=popupform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get a Newsletter
              </a>
            </div>
          )}
        </div>
      )
    }

    if ((editor.kind === ITEM_TYPE_MAIL ||
      editor.kind === ITEM_TYPE_CONFIRMATION_MAIL ||
      editor.kind === ITEM_TYPE_RESPONDER) &&
      model.sectionType == SECTION_TYPES.TWOCOL
    ) {
      const initialColumnMaxWidth = `${columnStyles.maxWidth}`.replace('px', '')
      const initialTotalMaxWidth = initialColumnMaxWidth * 2

      if (index === 0) {
        columnStyles.maxWidth = `${(initialTotalMaxWidth *
          (model.settings.values.firstColumnWidthPersent)) /
        100}px`
      } else {
        columnStyles.maxWidth = `${(initialTotalMaxWidth *
          (100 - model.settings.values.firstColumnWidthPersent)) /
        100}px`
      }

      columnStyles.verticalAlign = SECTION_VERTICAL_ALIGN_EMAIL_MAP[model.settings.values.alignItems] || 'top'
    }

    return (
      <div
        className={`column ${model.settings.values.stackColumnsOnMobile ? 'stack' : ''}`}
        style={{
          ...columnStyles,
          ...(model.isBoxed ? {
            ...model.borderRadiusStyles,
            borderStyle: borderStyles.borderStyle,
          } : {}),
          backgroundImage: undefined,
        }}
      >
        <table
          className={serverRender ? undefined : 'full-width'}
          border="0"
          cellSpacing="0"
          cellPadding="0"
          role="presentation"
          width="100%"
          style={borderStyles}
        >
          <Droppable model={column} acceptTypes={acceptTypes}>
            <tbody
              className={
                serverRender
                  ? ''
                  : `section-container ${column.classNames(
                      this.props.app.draggedComponent.type
                    )}`
              }
              data-content={
                serverRender
                  ? undefined
                  : formatMessage('column.empty-column.placeholder')
              }
            >
              <For each="item" index="index" of={column.items}>
                <Draggable data={item} move={true} key={item.id} isDraggable={item.type !== BLOCK_TYPES.PRODUCT}>
                  <Block
                    app={app}
                    editor={editor}
                    component={item}
                    index={index}
                    container={column}
                    serverRender={serverRender}
                    section={model}
                    columnIndex={columnIndex}
                  />
                </Draggable>
              </For>

              <If condition={!this.props.serverRender}>
                <tr>
                  <td>
                    <Placeholder position={column.placeholderPosition} />
                  </td>
                </tr>
              </If>
            </tbody>
          </Droppable>
        </table>
      </div>
    )
  }
}

export default inject('app', 'editor', 'serverRender')(observer(SectionColumn))
